import React, { useState } from 'react';
import axios from 'axios';
import { CheckCircle2, Send } from 'lucide-react';
import { toast } from 'sonner';

const API = (process.env.REACT_APP_BACKEND_URL || window.location.origin) + '/api/care';
const EMPTY = { name: '', organisation: '', email: '', phone: '', residents: '', message: '', website: '' };

const Field = ({ label, k, f, set, type = 'text', required, textarea }) => (
  <label className="block">
    <span className="block text-xs font-medium text-slate-500 mb-1">{label}{required && ' *'}</span>
    {textarea
      ? <textarea rows={3} value={f[k]} onChange={(e) => set({ ...f, [k]: e.target.value })} data-testid={`demo-${k}`} className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal-600/30" />
      : <input type={type} required={required} value={f[k]} onChange={(e) => set({ ...f, [k]: e.target.value })} data-testid={`demo-${k}`} className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal-600/30" />}
  </label>
);

export const CareDemoForm = () => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await axios.post(`${API}/public/demo-request`, f); setDone(true); }
    catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : Array.isArray(d) ? 'Please check the email address and phone number.' : 'Could not send. Please try again.');
    } finally { setBusy(false); }
  };
  if (done) {
    return (
      <div className="bg-white rounded-[28px] border border-emerald-200 p-10 text-center" data-testid="demo-success">
        <CheckCircle2 className="w-10 h-10 text-emerald-600 mx-auto" />
        <p className="mt-3 font-semibold text-slate-900">Thank you — we'll be in touch within 1 business day.</p>
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="bg-white rounded-[28px] border border-slate-200 p-6 sm:p-8 grid sm:grid-cols-2 gap-4" data-testid="care-demo-form">
      <Field label="Your name" k="name" f={f} set={setF} required />
      <Field label="Care home / organisation" k="organisation" f={f} set={setF} required />
      <Field label="Email" k="email" type="email" f={f} set={setF} required />
      <Field label="Phone / WhatsApp" k="phone" f={f} set={setF} required />
      <Field label="Number of residents" k="residents" f={f} set={setF} />
      <input className="hidden" tabIndex={-1} autoComplete="off" value={f.website} onChange={(e) => setF({ ...f, website: e.target.value })} name="website" />
      <div className="sm:col-span-2"><Field label="Anything we should know?" k="message" f={f} set={setF} textarea /></div>
      <button type="submit" disabled={busy} data-testid="demo-submit" className="sm:col-span-2 inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-teal-700 hover:bg-teal-800 text-white font-semibold disabled:opacity-60">
        <Send className="w-4 h-4" />{busy ? 'Sending…' : 'Request a demo'}
      </button>
    </form>
  );
};
